import { computed, type ComputedRef } from "vue";

export interface MaskProps {
  shape?: string;
  enabled?: boolean;
  positionX?: number;
  positionY?: number;
  backgroundColor?: string;
  showBackground?: boolean;
  shadow?: {
    enabled?: boolean;
    blur?: number;
    offsetX?: number;
    offsetY?: number;
    color?: string;
    opacity?: number;
  };
  align?: string;
  maskAspectRatio?: number;
}

export function useMediaMask(maskProps?: ComputedRef<MaskProps | undefined>) {
  // Определяем форму маски
  const maskShape = computed(() => {
    return maskProps?.value?.shape || "square";
  });

  // Проверяем, есть ли маска (не square)
  const hasMask = computed(
    () => !!maskShape.value && maskShape.value !== "square"
  );

  // Проверяем, включена ли маска
  const isMaskEnabled = computed(() => {
    return hasMask.value && (maskProps?.value?.enabled ?? false);
  });

  return {
    maskShape,
    hasMask,
    isMaskEnabled,
  };
}

